'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
var ReactDOM = require('react-dom');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var FormControl = require('../../node_modules/@material-ui/core/esm/FormControl/FormControl.js');
var InputLabel = require('../../node_modules/@material-ui/core/esm/InputLabel/InputLabel.js');
var Select = require('../../node_modules/@material-ui/core/esm/Select/Select.js');
var FilledInput = require('../../node_modules/@material-ui/core/esm/FilledInput/FilledInput.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var FormHelperText = require('../../node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  };
};

var SimpleSelect =
/*#__PURE__*/
function (_React$Component) {
  inherits(SimpleSelect, _React$Component);

  function SimpleSelect(props) {
    var _this;

    classCallCheck(this, SimpleSelect);

    _this = possibleConstructorReturn(this, getPrototypeOf(SimpleSelect).call(this, props));
    _this.state = {
      team: '',
      labelWidth: 0
    };
    return _this;
  }

  createClass(SimpleSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        labelWidth: ReactDOM__default["default"].findDOMNode(this.InputLabelRef).offsetWidth
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.setState(defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var classes = this.props.classes;
      return React__default["default"].createElement("form", {
        className: classes.root,
        autoComplete: "off"
      }, React__default["default"].createElement(FormControl["default"], {
        variant: "filled",
        className: classes.formControl
      }, React__default["default"].createElement(InputLabel["default"], {
        ref: function ref(_ref) {
          _this2.InputLabelRef = _ref;
        },
        htmlFor: "filled-simple"
      }, "Team"), React__default["default"].createElement(Select["default"], {
        value: this.state.team,
        onChange: function onChange(event) {
          return _this2.handleChange(event);
        },
        input: React__default["default"].createElement(FilledInput["default"], {
          labelWidth: this.state.labelWidth,
          name: "team",
          id: "filled-simple"
        })
      }, React__default["default"].createElement(MenuItem["default"], {
        value: ""
      }, React__default["default"].createElement("em", null, "None")), React__default["default"].createElement(MenuItem["default"], {
        value: 10
      }, "Jeffrey Lebowski"), React__default["default"].createElement(MenuItem["default"], {
        value: 20
      }, "Walter Sobchak"), React__default["default"].createElement(MenuItem["default"], {
        value: 30
      }, "Donny Karabatsos"))), React__default["default"].createElement(FormControl["default"], {
        variant: "filled",
        className: classes.formControl
      }, React__default["default"].createElement(InputLabel["default"], {
        ref: function ref(_ref2) {
          _this2.InputLabelRef = _ref2;
        },
        htmlFor: "filled-simple"
      }, "Team"), React__default["default"].createElement(Select["default"], {
        value: this.state.team,
        onChange: this.handleChange,
        input: React__default["default"].createElement(FilledInput["default"], {
          labelWidth: this.state.labelWidth,
          name: "team",
          id: "filled-simple"
        })
      }, React__default["default"].createElement(MenuItem["default"], {
        value: ""
      }, React__default["default"].createElement("em", null, "None")), React__default["default"].createElement(MenuItem["default"], {
        value: 10
      }, "Jeffrey Lebowski"), React__default["default"].createElement(MenuItem["default"], {
        value: 20
      }, "Walter Sobchak"), React__default["default"].createElement(MenuItem["default"], {
        value: 30
      }, "Donny Karabatsos")), React__default["default"].createElement(FormHelperText["default"], null, "Some important helper text")));
    }
  }]);

  return SimpleSelect;
}(React__default["default"].Component);

var SimpleSelect$1 = withStyles(styles)(SimpleSelect);

module.exports = SimpleSelect$1;
